import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description StarHouse icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { StarHouse } from '@sravni/design-system-icons'
 *
 * <StarHouse />
 * ```
 */
var StarHouse = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "StarHouse", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M2.402 9.444 10 2.517a1.064 1.064 0 0 1 1.471 0l7.598 6.927", stroke: "currentColor", strokeWidth: "1.5", strokeMiterlimit: "10", strokeLinecap: "round" }),
    React.createElement("path", { d: "M17.736 8v8.572c0 .789-.626 1.428-1.4 1.428h-11.2c-.773 0-1.4-.64-1.4-1.428V8", stroke: "currentColor", strokeWidth: "1.5", strokeMiterlimit: "10" }),
    React.createElement("path", { d: "M10.37 7.178a.4.4 0 0 1 .734 0l.953 2.204a.4.4 0 0 0 .316.239l2.302.29a.4.4 0 0 1 .23.682l-1.735 1.713a.4.4 0 0 0-.112.358l.455 2.446a.4.4 0 0 1-.598.416l-1.973-1.178a.4.4 0 0 0-.41 0l-1.974 1.178a.4.4 0 0 1-.598-.416l.455-2.446a.4.4 0 0 0-.112-.358l-1.736-1.713a.4.4 0 0 1 .23-.681L9.1 9.62a.4.4 0 0 0 .317-.239l.953-2.204Z", stroke: "currentColor", strokeWidth: "1.5" }))); });

export { StarHouse };
//# sourceMappingURL=StarHouse.js.map
